import moment from "moment";

const indianPinRegex = /^[1-9][0-9]{5}$/;
const allSameRegex = /^(\d)\1{5}$/;
const lastFourSameRegex = /^[1-9][0-9]{1}(\d)\1{3}$/;

/*export const convertIntoLakh = (amount) => {
    if (amount !== "" && amount !== undefined) {
        if (amount >= 100000 && amount < 10000000) {
            return `${(amount / 100000).toFixed(2)} Lakh`
        } else if (amount >= 10000000) {
            return `${(amount / 10000000).toFixed(2)} Crore`
        }
        else if (amount >= 1000) {
            return `${(amount / 1000).toFixed(2)} Thousand`
        }
        return amount;
    } else {
        return "0";
    }
};
*/
export const convertIntoLakh = (amount) => {
    if (amount === "" || amount === undefined || amount === null) {
        return "0";
    }

    const formatNumber = (num) => {
        return Number.isInteger(num)
            ? num.toString()
            : num.toFixed(2).replace(/\.?0+$/, "");
    };

    if (amount >= 100000 && amount < 10000000) {
        return `${formatNumber(amount / 100000)} Lakh`;
    }

    if (amount >= 10000000) {
        return `${formatNumber(amount / 10000000)} Crore`;
    }

    if (amount >= 1000) {
        return `${formatNumber(amount / 1000)} Thousand`;
    }

    return amount.toString();
};


export const convertIntoLakhWithoutZero = (amount) => {
    if (amount !== "" && amount !== undefined) {
        if (amount >= 100000 && amount < 10000000) {
            const lakhAmount = amount / 100000;
            return `${Number.isInteger(lakhAmount) ? lakhAmount.toFixed(0) : lakhAmount.toFixed(1)} Lakh`;
        } else if (amount >= 10000000) {
            const croreAmount = amount / 10000000;
            return `${Number.isInteger(croreAmount) ? croreAmount.toFixed(0) : croreAmount.toFixed(1)} Crore`;
        } else if (amount >= 1000) {
            const thousandAmount = amount / 1000;
            return `${Number.isInteger(thousandAmount) ? thousandAmount.toFixed(0) : thousandAmount.toFixed(2)} Thousand`;
        }
        return amount;
    }
};

export const convertIntoLakhWithoutRoundOff = (amount) => {
    if (amount !== "" && amount !== undefined && !isNaN(amount)) {

        // helper to truncate without rounding
        const truncateTo2Decimals = (num) => {
            return Math.floor(num * 100) / 100;
        };

        if (amount >= 100000 && amount < 10000000) {
            const lakhAmount = truncateTo2Decimals(amount / 100000);
            return `${lakhAmount} Lakh`;
        } else if (amount >= 10000000) {
            const croreAmount = truncateTo2Decimals(amount / 10000000);
            return `${croreAmount} Crore`;
        } else if (amount >= 1000) {
            const thousandAmount = truncateTo2Decimals(amount / 1000);
            return `${thousandAmount} Thousand`;
        }

        return amount;
    }
};


export const CommaSeprator = (input) => {
    if (input !== null && input !== undefined) {

        let value = /^\d+\.\d+$/.test(input+'') ? input.toString().split(".")[0] : input;
        let decimalValue = /^\d+\.\d+$/.test(input+'') ? input.toString().split(".")[1] : "";
        let rupee = value.toString();
        let newRupee = rupee.substring(rupee.length - 3);
        let other = rupee.substring(0, rupee.length - 3);
        if (other !== '')
            newRupee = ',' + newRupee;
        ////console.log(newRupee);
        let formatedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
        return /^\d+\.\d+$/.test(input+'') ? formatedValue+"."+ decimalValue  :formatedValue;
    }
};
export const CountYear = (yearVal) => {
    let today = new Date();
    today = new Date(today.setFullYear(today.getFullYear() + parseInt(yearVal)));
    let year = today.getFullYear();
    return year;
};
export const getAge = (birthdate) => {
    if (birthdate instanceof Date)
        return moment().diff(moment(birthdate), 'years');
    else if (typeof birthdate === "string")
        return moment().diff(moment(birthdate, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY/MM/DD", "DD/MM/YYYY"]), 'years');
};

export const decimaNumberFormat = (num) => {
    if (num === null || num === undefined) {
        return ''; 
    }
        return num % 1 === 0 ? num.toString() : parseFloat(num).toFixed(2);
 
}

export const getMaskForNameWithMaxLength = (maxLength) => {
        // Return an array of `num` elements with the specified pattern
    return Array.from({ length: maxLength }, (_, index) => index === 0 ? /[a-zA-Z]/ : /[a-zA-Z\s]/);
    }


export const addElipsis = (str,length) => {
    const breakStr = str.split(' ');
    if (breakStr.length > 1) {
        return str;
    } else {
        return str.slice(0,length) + '... '; 
    }
}

export const mobilePattern = /^(\d)\1{5}/  // /(0{6,}|1{6,}|2{6,}|3{6,}|4{6,}|5{6,}|6{6,}|7{6,}|8{6,}|9{6,})/;


export const isValidMobileFormat = (mobile) => {
    return /^[6-9][0-9]{9}$/.test(mobile);
};

export const isAllSameMobileNumber = (mobile) => {
    return /^(\d)\1{9}$/.test(mobile);
};

export const isSequentialMobileNumber = (mobile) => {

    let ascending = true;
    let descending = true;

    for (let i = 1; i < mobile.length; i++) {

        const previous = Number(mobile[i - 1]);
        const current = Number(mobile[i]);

        // Ascending sequence
        // Example: 6789012345
        if (current !== (previous + 1) % 10) {
            ascending = false;
        }

        // Descending sequence
        // Example: 9876543210
        if (current !== (previous - 1 + 10) % 10) {
            descending = false;
        }
    }

    return ascending || descending;
};

export const isRepeatingMobilePattern = (mobile) => {

    for (let patternLength = 1; patternLength <= 5; patternLength++) {

        const pattern = mobile.substring(0, patternLength);

        let generated = "";

        while (generated.length < mobile.length) {
            generated += pattern;
        }

        generated = generated.substring(0, mobile.length);

        if (generated === mobile) {
            return true;
        }
    }

    return false;
};

export const hasMoreThanFiveConsecutiveSameDigits = (mobile) => {
    return /(\d)\1{5,}/.test(mobile);
};

export const getMobileValidationError = (mobile) => {

    // NULL / undefined
    if (mobile === null || mobile === undefined) {
        return "Please enter mobile number";
    }

    // Blank
    if (mobile.trim() === "") {
        return "Please enter mobile number";
    }

    // Basic format
    if (!isValidMobileFormat(mobile)) {
        return "Please enter a valid 10-digit mobile number";
    }

    // Condition 1
    if (isAllSameMobileNumber(mobile)) {
        return "Mobile number with all same digits is not allowed";
    }

    // Condition 2
    if (isSequentialMobileNumber(mobile)) {
        return "Sequential mobile numbers are not allowed";
    }

    // Condition 3
    if (isRepeatingMobilePattern(mobile)) {
        return "Repeating/alternating mobile number is not allowed";
    }

    // Condition 4
    if (hasMoreThanFiveConsecutiveSameDigits(mobile)) {
        return "More than 5 consecutive same digits are not allowed";
    }

    // Condition 5
    if (isPalindromeMobileNumber(mobile)) {
        return "Palindrome mobile numbers are not allowed";
    }

    // Valid mobile number
    return "";
};

export const isPalindromeMobileNumber = (mobile) => {

    const reversedMobile = mobile
        .split("")
        .reverse()
        .join("");

    return mobile === reversedMobile;
};


/*export const pinRepeatedPattern = /^(\d)\1{5}$/;*/

export const pinRepeatedPattern = (pin) => {
    if (!indianPinRegex.test(pin)) return false; // invalid format
    if (allSameRegex.test(pin)) return false;    // all same digits
    if (lastFourSameRegex.test(pin)) return false; // last 4 same
    return true;
};


export const pinRepeatedFourTime = /(.)\1{3}/;


export const calculateAge = (dob) => {
    let today = new Date();
    let birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    let month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};


export const formatValueInRupeeFormat = (amt) => {
    if (!amt) return '';
    return `₹ ${parseInt(amt).toLocaleString('en-IN')}`;
};


export const formatDate = (date, format = "dd-mm-yyyy") => {
    if (!date) return "";

    const d = new Date(date);
    if (isNaN(d)) return ""; // return empty if invalid date

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    switch (format.toLowerCase()) {
        case "yyyy-mm-dd":
            return `${year}-${month}-${day}`;
        case "mm-dd-yyyy":
            return `${month}-${day}-${year}`;
        case "dd-mm-yyyy":
        default:
            return `${day}-${month}-${year}`;
    }
};



export function isBeforeSep22_2025() {
    const today = new Date();
     const cutoff = new Date('2025-09-22T00:00:00Z'); 
    return today < cutoff;
}


export const parseStringArray = (inputValue) => {
    try {
        if (!Array.isArray(inputValue) || inputValue.length == 0 || typeof inputValue[0] !== 'string') {
            throw new Error('Invalid value format');
        }
        const rawString = `[${inputValue[0]}]`;
        const parsed = JSON.parse(rawString);

        if (!Array.isArray(parsed)) {
            throw new Error('Parsed result is not an array');
        }

        return parsed;

    } catch (error) {
        console.log('Failed to parse: ', error);
        return [];
    }
};


export const getAnnualIncomeList = () => {
    let res = [];
    for (let i = 1; i <= 25; i++) {
        res.push({ name: i === 25 ? '₹25 Lakh & Above' : "₹"+i+' Lakh', code: i+'00000'});
    }
    return res;
}


export const getPaymentTermList = () => {
    let res = [];
    for (let i = 1; i <= 25; i++) {
        res.push({ name: i === 1 ? ' Single Pay' : i + ' Years', code: i+"" });
    }
    return res;
}

